import Facet from './Facet.es6';

export default class Continuous2DFacet extends Facet {

  filter(extent) { // extent = [start, end]
    this._extent = extent;
    this.selectionChanged.dispatch(this._extent);
  }

  get extent() {
    debugger;
    // if (!this._extent) {
    //   const first = this.groups[0][this.idKey];
    //   const last = this.groups[this.groups.length - 1][this.idKey];
    //   return [first, last];
    // }
    return this._extent;
  }

  get query() {
    if (!this._extent) return null;
    return {
      [this._queryParams[0]]: this._extent[0],
      [this._queryParams[1]]: this._extent[1],
      [this._queryParams[2]]: this._extent[2],
      [this._queryParams[3]]: this._extent[3],
    };
  }

}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/models/facets/Continuous2DFacet.es6
 **/